import { ParticipantInfo } from "../participant/participant.info";

export class ActionOrganizationScope {
    enable: boolean;
    action: ActionScope;
    scope: OrganizationPotentialOwner;
}

export class ActionOrganizationScopeDesign {
    enable: boolean;
    action: ActionScope;
    scope: OrganizationPotentialOwner;
}
export class OrganizationPotentialOwner {
    /**
     * 作用域：AssignUser, Transfer, AddSignFront, AddSignBehind
     */
    actionScope: ActionScope;
    /**
     * 部门：DEPARTMENT；单位：UNIT
     */
    organizationLevel: OrganizationLevel;
    /**
     * 组织Id：currentDepartment, currentUnit
     */
    organizationId: string;
    /**
     * 组织编号
     */
    organizationCode: string;
    /**
     * 组织名称
     */
    organizationName: string;
    /**
     * 包含下级
     */
    includeChildren: boolean;
    /**
     * 遍历父级
     */
    parentsUntil: boolean;
    /**
     * variable 变量值
     * expression 表达式值
     * constant 常量值
     */
    tag: string;

    /**
     * 先改一下  存人员信息
     */
    participantInfo: ParticipantInfo;
}

export enum ActionScope {
    /**
     * 指派
     */
    AssignUser = 'AssignUser',
    /**
     * 移交
     */
    Transfer = 'Transfer',
    /**
     * 征询
     */
    AddSignFront = 'AddSignFront',
    /**
     * 加签
     */
    AddSignBehind = 'AddSignBehind',
    /**
     * 知会
     */
    Notify = "Notify",
}

export enum OrganizationLevel {
    /**
     * 部门
     */
    DEPARTMENT = 'DEPARTMENT',
    /**
     * 单位
     */
    UNIT = 'UNIT',
    /**
     * 默认值
     */
    DEFAULT = 'DEFAULT',
    
    VARORGANIZATION = 'VARORGANIZATION'

    // ASSIGNORGANIZATION = 'ASSIGNORGANIZATION'
}
